import { Link } from 'react-router-dom';
import StaticPage from '../components/StaticPage';

const SECTIONS = [
  {
    title: 'For Diners',
    links: [
      { to: '/', label: 'Home' },
      { to: '/deals', label: 'Browse deals' },
      { to: '/how-it-works', label: 'How it works' },
    ],
  },
  {
    title: 'For Restaurants',
    links: [
      { to: '/business/register', label: 'List your restaurant' },
      { to: '/business/login', label: 'Restaurant login' },
      { to: '/pricing', label: 'Pricing plans' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: '/careers', label: 'Careers' },
      { to: '/sitemap', label: 'Site map' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/terms', label: 'Terms of Use' },
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/accessibility', label: 'Accessibility' },
    ],
  },
];

export default function SitemapPage() {
  return (
    <StaticPage title="Site Map">
      <p>A full list of pages available on halfprice.ca.</p>
      {SECTIONS.map(section => (
        <div key={section.title}>
          <h2>{section.title}</h2>
          <ul>
            {section.links.map(l => (
              <li key={l.to}><Link to={l.to}>{l.label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </StaticPage>
  );
}
